import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=5254dc7c&"
import script from "./EditReport.vue?vue&type=script&lang=ts&"
export * from "./EditReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports